export enum FileIntegrityCheckModeType {
  Single = 1,
  Multi = 2
}
